import React from "react";
import { Box, SxProps, Theme } from "@mui/material";
import { useAuthenticatedFileUrl } from "../../hooks/useAuthenticatedFileUrl";
import { isProtectedApiFileUrl } from "../../utils/authenticatedFileUrl";

type AuthenticatedMenuImageProps = {
  src: string;
  sx?: SxProps<Theme>;
  visible?: boolean;
  onLoad?: () => void;
};

export const AuthenticatedMenuImage: React.FC<AuthenticatedMenuImageProps> = ({
  src,
  sx,
  visible = true,
  onLoad,
}) => {
  const { url } = useAuthenticatedFileUrl(src);
  const imgSrc = url ?? (isProtectedApiFileUrl(src) ? undefined : src);

  return (
    <Box
      component="img"
      src={imgSrc}
      sx={{
        ...sx,
        display: visible ? "block" : "none",
      }}
      onLoad={onLoad}
    />
  );
};
